const BUTTON_SIZES = {
    LARGE: "large",
    MEDIUM: "medium",
    SMALL: "small"
};

export default BUTTON_SIZES;
